import logoColor from "../../../packages/design-system/assets/LOGO_CLR.svg";
import logoNegative from "../../../packages/design-system/assets/LOGO_NEG.svg";

export const logoColorUrl = logoColor;
export const logoNegativeUrl = logoNegative;
